import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroModule } from '../../shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { InstagramRoutingModule } from './instagram-routing.module';
import { InstagramPostsComponent } from './Components/instagram-posts/instagram-posts.component';
import { InstagramPostDetailsComponent } from './Components/instagram-post-details/instagram-post-details.component';
import { InstagramService } from './Services/instagram.service';
import { InstagramCommentsComponent } from './Components/instagram-comments/instagram-comments.component';



@NgModule({
  declarations: [
    InstagramPostsComponent,
    InstagramPostDetailsComponent,
    InstagramCommentsComponent,
  ],
  providers: [
    InstagramService,
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    InstagramRoutingModule,
    FontAwesomeModule,
  ]
})
export class InstagramModule { }